<template>
    <div class="search-input-wrap">
        <input v-model="search" type="text" :placeholder="$t('common.search')" class="search-input">
        <i class="fas fa-search search-input-icon"></i>
    </div>
</template>

<script>
export default {
    emits: [ "update:modelValue" ],
    props: {
        modelValue: String
    },
    data() {
        return {
            search: this.modelValue
        }
    },
    watch: {
        search() {
            this.$emit("update:modelValue", this.search);
        }
    }
}
</script>

<style>
    .search-input-wrap {
        position: relative;        
    }
    .search-input-wrap .search-input {
        background-color: #f5f5f6;
        border: 1px solid #E8E8EC;
        width: 100%;
        border-radius: 8px;
        height: 48px;
        line-height: 48px;
        outline: 0;
        box-sizing: border-box;
        padding: 0 48px 0 16px;
    }   
    .search-input-wrap .search-input-icon {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        right: 16px;
        font-size: 1.5em;
        color: #7b7b7b;
        font-weight: 500;
    } 
</style>